import { defineMessages } from 'react-intl';

export default defineMessages({
  judge: 'Judge Rights',
  rejectionComments: 'Rejection Comments',
  title: 'Review Rights'
});
